import {
  FormControl,
  RadioGroup,
  FormLabel,
  FormControlLabel,
  Radio,
  RadioGroupProps,
  FormHelperText,
  Typography,
  Box,
  SxProps,
} from '@mui/material';
import { useController } from 'react-hook-form';
import { generateError } from 'Regex';
import { InfoText } from 'Components';

type Options = {
  value: string | boolean;
  label: string;
};

interface ICustomRadioGroup extends RadioGroupProps {
  id?: string;
  hideId?: boolean;
  removeBold?: boolean;
  options: Options[];
  name: string;
  description?: string;
  infoText?: string;
  callback?: Function;
  sx?: SxProps;
}
export const CustomRadioGroup: React.FC<ICustomRadioGroup> = (props) => {
  const { id, options, name, ...RadioProps } = props;

  let {
    field: { onChange, value, ref, ...fields },
    fieldState: { error },
  } = useController({
    name: name,
    defaultValue: null,
  });

  return (
    <FormControl error={Boolean(error)}>
      {id ? (
        <FormLabel htmlFor={id}>
          {!props.hideId && (
            <Typography
              color={error ? 'error' : 'text.primary'}
              fontWeight={props.removeBold ? 400 : 700}
            >
              {id}
            </Typography>
          )}
          {props.infoText && (
            <Box sx={{ mt: 1, mb: 1 }}>
              <InfoText text={props.infoText} />
            </Box>
          )}
          {props.description && (
            <Typography color='text.primary'>{props.description}</Typography>
          )}
        </FormLabel>
      ) : null}
      <RadioGroup
        aria-labelledby={id}
        aria-label={id}
        {...RadioProps}
        {...fields}
        name={name}
        value={value}
        onChange={(e, value) => {
          if (props.callback) props.callback(value);
          onChange(value);
        }}
        sx={{
          marginBottom: 0,
          ...props.sx,
        }}
      >
        {options.map(({ value, label }) => (
          <FormControlLabel
            control={<Radio inputRef={ref} />}
            key={label}
            value={value}
            label={<Typography fontSize={14}>{label}</Typography>}
          />
        ))}
      </RadioGroup>
      {error?.message && (
        <FormHelperText>{generateError(id!, error.message)}</FormHelperText>
      )}
    </FormControl>
  );
};
